import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { htmlLangTag, localeFromPathname } from '../lib/locale';

/** Keeps `<html lang>` in sync with the URL locale segment. */
export function LocaleHtmlLang() {
  const { pathname } = useLocation();
  useEffect(() => {
    const loc = localeFromPathname(pathname);
    document.documentElement.lang = htmlLangTag(loc);
  }, [pathname]);
  return null;
}
